import { css } from 'lit'

export const mapDownloadPopupStyles = css`
    .loading-img {
        width: 158px;
        height: 158px;
        margin-bottom: 10px;
    }

    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3px;
        margin-bottom: 24px;
    }

    p {
        margin: 0;
        line-height: 24px;
        font-family: 'Maersk Text';
    }

    .loading-primary {
        font-size: 19px;
    }

    .loading-secondary {
        font-size: 14px;
    }

    .progress-value {
        color: var(--primary-blue-300, white);
    }
`
